import { inject } from '@angular/core';
import {ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot} from '@angular/router';
import {UserEventsService} from '@services';
import {take, of, EMPTY} from 'rxjs';
import {RaceRegistration, UserEvent} from "@model";
import {mergeMap} from "rxjs/operators";
import {MY_TRACEY} from "../app-routing.module";

export const MyOrderDetailsResolver: ResolveFn<RaceRegistration | undefined> =
    (route: ActivatedRouteSnapshot,
     state: RouterStateSnapshot,
     userEventsService: UserEventsService = inject(UserEventsService),
     router: Router = inject(Router)) => {
        const registrationId: number | undefined = +route.queryParams['orderId'] ? +route.queryParams['orderId'] : undefined;
        if (registrationId) {
            return userEventsService.fetchUserRegistration(registrationId).pipe(
                take(1),
                mergeMap((res: UserEvent | undefined) => {
                    if (res) {
                        return of(res);
                    } else {
                        router.navigate([MY_TRACEY]);
                        return EMPTY;
                    }
                })
            );
        } else {
            router.navigate([MY_TRACEY]);
            return EMPTY;
        }
    };
